interface PageBtnNavOptions {
  currentPage: number;
  total: number;
  size: number;
  mobileBtnsNum: number;
  desktopBtnsNum: number;
}

export default function usePageBtnNavRange({ total, size, currentPage, mobileBtnsNum, desktopBtnsNum }: PageBtnNavOptions) {
  if (!size || !total) {
    return { mobile: [1], desktop: [1], pageCount: 1 };
  }

  const pageCount = Math.ceil(total / size);
  const pageArr = Array.from(Array(pageCount).keys()).map((i, idx) => idx + 1);

  const mobileRange = getStartAndEndIndex(currentPage, mobileBtnsNum);
  const desktopRange = getStartAndEndIndex(currentPage, desktopBtnsNum);

  return {
    mobile: pageArr.slice(mobileRange.startIndex, mobileRange.endIndex),
    desktop: pageArr.slice(desktopRange.startIndex, desktopRange.endIndex),
    pageCount,
  };
}

const getStartAndEndIndex = (currentPage: number, range: number) => {
  const remainder = currentPage % range;
  const start = currentPage - remainder;
  const startIndex = remainder === 0 && currentPage >= range ? start - range : start;
  const endIndex = startIndex + range;
  return { startIndex, endIndex };
};
